/* Tonic Home V2: gift finder. snippets/th-gift-finder.liquid renders every person and budget
   pair's picks into a <template>; choosing a chip copies that pair's cards in, so nothing is fetched.
   Pairs topped up from the budget collection show the fallback note. */
class ThFinder extends HTMLElement {
  connectedCallback() {
    this.cards = this.querySelector('.th-finder__cards');
    this.note = this.querySelector('.th-finder__note');
    this.pool = this.querySelector('.th-finder__pool');
    this.filled = (this.querySelector('.th-finder__filled')?.dataset.keys || '').split(' ').filter(Boolean);
    this.querySelectorAll('[role="radiogroup"]').forEach((group) => {
      const chips = [...group.querySelectorAll('.th-finder__chip')];
      chips.forEach((chip, i) => {
        chip.tabIndex = chip.getAttribute('aria-checked') === 'true' ? 0 : -1;
        chip.addEventListener('click', () => this.choose(chips, chip));
        chip.addEventListener('keydown', (event) => {
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          const next = chips[(i + step + chips.length) % chips.length];
          this.choose(chips, next);
          next.focus();
        });
      });
    });
    this.show();
  }

  choose(chips, chip) {
    chips.forEach((c) => {
      c.setAttribute('aria-checked', c === chip);
      c.tabIndex = c === chip ? 0 : -1;
    });
    this.show();
  }

  show() {
    const who = this.querySelector('[data-who][aria-checked="true"]')?.dataset.who || '0';
    const budget = this.querySelector('[data-budget][aria-checked="true"]')?.dataset.budget || '0';
    const key = `${who}-${budget}`;
    const picks = [...this.pool.content.querySelectorAll('.th-finder__card')]
      .filter((card) => card.dataset.keys.split(' ').includes(key))
      .slice(0, 3)
      .map((card) => document.importNode(card, true));
    this.cards.replaceChildren(...picks);
    this.note.textContent = this.filled.includes(key) ? this.dataset.fallbackNote : this.dataset.note;
  }
}

if (!customElements.get('th-finder')) customElements.define('th-finder', ThFinder);
